import axios from 'axios';
import { useMutation } from '@tanstack/react-query';

import { TypeMaster } from 'models/type/TypeMaster';

export function useEditWorkflowTypeMaster() {
    return useMutation({
        mutationFn: (request: TypeMaster) => {
            const accessToken = localStorage.getItem('WF_APPLICATION');

            return axios.put('/v2/configuration/workflow/type', request, {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        }
    });
}
